import { PublicClientApplication } from '@azure/msal-browser';

const runtimeEnv = window.__ENV__ || {};
const azureClientId = runtimeEnv.VITE_AZURE_CLIENT_ID || import.meta.env.VITE_AZURE_CLIENT_ID;
const azureTenantId = runtimeEnv.VITE_AZURE_TENANT_ID || import.meta.env.VITE_AZURE_TENANT_ID;

// Configurazione MSAL per il flusso di login Azure AD (SPA redirect).
// In Docker clientId e tenantId arrivano da env.js; in locale usa le variabili Vite.
// Il redirect URI è dinamico (window.location.origin) per funzionare sia in locale che in produzione.
// Il redirect URI deve essere registrato come tipo "Single-Page Application" nell'App Registration Azure.
const msalConfig = {
  auth: {
    clientId: azureClientId,
    authority: `https://login.microsoftonline.com/${azureTenantId}`,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

// Scope GUID-based ({clientId}/.default): necessario perché l'App Registration non ha un
// Application ID URI configurato (api://{clientId}). Con questo scope Azure include il claim
// "roles" nell'access token, che il backend usa per determinare il ruolo dell'utente.
export const loginRequest = {
  scopes: [`${azureClientId}/.default`],
};

export const msalInstance = new PublicClientApplication(msalConfig);

// initialize() deve essere chiamata prima di qualsiasi interazione MSAL (login, redirect, ecc.).
// Esportiamo la promise per poterla attendere una sola volta all'avvio dell'app.
export const msalReady = msalInstance.initialize();
